import Cookies from 'universal-cookie';

import bridgeData from '@/_mappers/bridge-data';
import { ROUTES } from '@/_navigation/routes';
import { FILTER } from '@/_static/constants';

import { CATEGORIES } from '../_mappers/category-mapper';

export const setCookie = (key, value, days) => {
  const cookies = new Cookies();
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expiration = new Date(date.toUTCString());
  const options = {
    path: ROUTES.QUALIFY.link,
    expires: expiration,
  };
  cookies.set(key, value, options);
};

export const getCookie = (key) => {
  const cookies = new Cookies();
  if (cookies.get(key)) {
    return cookies.get(key);
  }
  return null;
};

export const getFormData = () => {
  return localStorage.getItem('formData') ? JSON.parse(localStorage.getItem('formData')) : null;
};

export const initCampaignObj = () => {
  let campaignObj = {};
  if (getParameterByName('campaign')) {
    const queryString = window.location.search;
    campaignObj = {
      referral: document.referrer,
      firstPage: window.location.href,

      campaign: getParameterByName('campaign') ?? '',
      utm_campaign: getParameterByName('utm_campaign') ?? '',
      utm_source: getParameterByName('utm_source') ?? '',
      utm_medium: getParameterByName('utm_medium') ?? '',
      AdGroup: getParameterByName('AdGroup') ?? '',
      Keyword: getParameterByName('Keyword') ?? '',

      gclid: getParameterByName('gclid') ?? '',
      afid: getParameterByName('afid') ?? '',
      hitid: getParameterByName('hitid') ?? '',
      subid: getParameterByName('subid') ?? '',
      params: queryString,
    };
    setCookie('campaignObj', JSON.stringify(campaignObj), 2);
  } else if (getCookie('campaignObj')) {
    campaignObj = JSON.parse(JSON.stringify(getCookie('campaignObj')));
  }
  return campaignObj;
};

/* eslint-disable no-unused-vars */
export const getDataObjectByPagePath = (currentPage) => {
  let obj = {};
  for (const [key, value] of Object.entries(bridgeData)) {
    if (Object.keys(value)[0] === currentPage) {
      obj = value[Object.keys(value)[0]];
      break;
    }
    for (const [key2, value2] of Object.entries(value.questions)) {
      if (Object.keys(value2)[0] === currentPage) {
        obj = value2[Object.keys(value2)[0]];
        break;
      }
    }
  }
  return obj;
};

/* eslint-disable no-unused-vars */
export const getDataObjectByAPI = (api) => {
  for (const [_, category] of Object.entries(bridgeData)) {
    for (const [__, questions] of Object.entries(category.questions)) {
      for (const [___, value3] of Object.entries(questions)) {
        if (value3?.api === api) {
          return value3;
        }
      }
    }
  }

  // Special handling for ATP_14__c: return the object out of bridgeData where api === "ATP_14__c"
  if (api === 'ATP_14__c') {
    for (const [_, category] of Object.entries(bridgeData)) {
      // Check top-level fields (excluding 'questions')
      for (const key of Object.keys(category)) {
        if (key !== 'questions' && category[key]?.api === api) {
          return category[key];
        }
      }
    }
  }
  return {};
};

export const getCurrentQuestions = (currentPage) => {
  let obj = {};
  for (const [key, value] of Object.entries(bridgeData)) {
    if (Object.keys(value)[0] === currentPage) {
      obj = value[Object.keys(value)[0]];
      break;
    }
  }
  const { questions } = obj;
  if (questions) {
    return questions;
  }
  return null;
};

export const replaceWithName = (str, leadObj) => {
  if (!str) {
    return str;
  }
  return str.includes('{name}') ? str.replace('{name}', leadObj?.First_Name__c) : str;
};

export const updateLocalStorage = (localKey, obj) => {
  const data = localStorage.getItem(localKey) ? JSON.parse(localStorage.getItem(localKey)) : {};
  let newData = null;
  if (data) {
    newData = { ...data, ...obj };
  }

  localStorage.setItem(localKey, JSON.stringify(newData));
};

export const getLocalStorageValueByKey = (property) => {
  const formData = localStorage.getItem('formData') ? JSON.parse(localStorage.getItem('formData')) : {};
  if (formData.length > 0) {
    for (const [key, value] of Object.entries(formData)) {
      if (key === property) {
        return value;
      }
    }
  }
  return null;
};

export const getParameterByName = (name, url = window.location.href) => {
  const n_name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${n_name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const buildScoreMap = (formData) => {
  const getValue = (key) => {
    for (const [key1, value] of Object.entries(formData)) {
      if (key === key1) {
        return value;
      }
    }
    return null;
  };

  // build score mapping
  const objArr = [];
  for (const [key] of Object.entries(formData)) {
    if (!FILTER.has(key)) {
      objArr.push(getDataObjectByAPI(key));
    }
  }

  const scoreMap = new Map();
  /* eslint-disable no-unused-vars */
  for (const [key, value] of Object.entries(objArr)) {
    const { api, category } = value;
    const fieldVal = api && getValue(api);
    if (value?.list && value.list.length > 0) {
      for (const [key2, value2] of Object.entries(value.list)) {
        if (value2?.options && value2.options.length > 0) {
          for (const obj of value2.options) {
            const { option, score } = obj;
            if (option === fieldVal) {
              if (scoreMap.get(category) != null) {
                scoreMap.set(category, scoreMap.get(category) + score);
              } else {
                scoreMap.set(category, score);
              }
            }
          }
        }
      }
    }
  }

  return scoreMap;
};

// Helper function to get score for a specific question
export const getQuestionScore = (formData, apiKey) => {
  const dataObj = getDataObjectByAPI(apiKey);
  if (!dataObj) return 0;

  const userAnswer = formData[apiKey];
  if (!userAnswer) return 0;

  if (dataObj?.list && dataObj.list.length > 0) {
    for (const listItem of dataObj.list) {
      if (listItem?.options && listItem.options.length > 0) {
        for (const optionObj of listItem.options) {
          const { option, score } = optionObj;
          if (option === userAnswer) {
            return score;
          }
        }
      }
    }
  }

  return 0;
};

// Helper function to get all scores with details, using only questions with isScoringQuestion = true
export const getDetailedScoresFiltered = (formData) => {
  const scoreMap = buildScoreMap(formData);
  let detailedScores = {};

  for (const [category, totalScore] of scoreMap.entries()) {
    detailedScores[category] = {
      totalScore,
      questions: [],
    };

    // Find all questions for this category
    for (const [key] of Object.entries(formData)) {
      if (!FILTER.has(key)) {
        const dataObj = getDataObjectByAPI(key);
        if (dataObj?.category === category && dataObj?.scoreField && dataObj?.isScoringQuestion === true) {
          const questionScore = getQuestionScore(formData, key);
          detailedScores[dataObj?.category].questions.push({
            apiKey: key,
            userAnswer: formData[key],
            score: questionScore,
          });
        }
      }
    }
  }

  // Add appScore for specific apiKeys
  const appScoreApiKeys = ['Currently_Employed_Nrse_Emerg_Pt_Care__c', 'Highest_Education_Level__c', 'ATP_5__c'];

  let totalReadinessScore = 0;
  let readinessQuestions = [];
  for (const category in detailedScores) {
    if (detailedScores[category]?.questions?.length > 0) {
      detailedScores[category].questions = detailedScores[category].questions.map((q) => {
        if (appScoreApiKeys.includes(q.apiKey)) {
          const readinessScore = getQuestionScore(formData, q.apiKey);
          totalReadinessScore += readinessScore;
          readinessQuestions.push(q);
          return {
            ...q,
            readinessScore,
          };
        }
        return q;
      });
    }
  }

  if (formData.Stages_Completed__c.indexOf(CATEGORIES.BP_PRE_BUY_PURCHASED) > -1) {
    totalReadinessScore += 30;
    readinessQuestions.push({ category: CATEGORIES.BP_PRE_BUY_PURCHASED });
  }

  if (formData.Stages_Completed__c.indexOf(CATEGORIES.BP_PRE_BUY_LEARN) > -1) {
    totalReadinessScore += 10;
    readinessQuestions.push({ category: CATEGORIES.BP_PRE_BUY_LEARN });
  }

  // detailedScores
  if (detailedScores[CATEGORIES.BP_PRE_BUY_RES_MEET]) {
    totalReadinessScore += detailedScores[CATEGORIES.BP_PRE_BUY_RES_MEET].totalScore;
    readinessQuestions.push({ category: CATEGORIES.BP_PRE_BUY_RES_MEET });
  }

  if (detailedScores[CATEGORIES.READINESS]) {
    detailedScores.Readiness = {
      totalScore: detailedScores.Readiness.totalScore + totalReadinessScore,
      questions: [...detailedScores.Readiness.questions, ...readinessQuestions],
    };
  } else if ((totalReadinessScore ?? 0) > 0) {
    detailedScores = {
      ...detailedScores,
      [CATEGORIES.READINESS]: { totalScore: totalReadinessScore, questions: readinessQuestions },
    };
  }

  return detailedScores;
};
